<template>
  <router-view />
</template>

<script>
import JQuery from "jquery";
const $ = JQuery;

export default {
  mounted() {
    /*===============================================
      Preloaders
    ===============================================*/
    var $body = $("body");

    $(window).on("load", function () {
      $body.addClass("loaded");
    });

    if ($body.attr("data-preloader") === "1") {
      $body.append($("<div class='preloader preloader-1'><div><span></span></div></div>"));
    }
    else if ($body.attr("data-preloader") === "2") {
      $body.append($("<div class='preloader preloader-2'><div><svg class='loader-circular' viewBox='25 25 50 50'><circle class='loader-path' cx='50' cy='50' r='20' fill='none' stroke-width='2' stroke-miterlimit='10'/></svg></div></div>"));
    }
    else if ($body.attr("data-preloader") === "3") {
      $body.append($("<div class='preloader preloader-3'><div><span></span><span></span><span></span></div></div>"));
    }
    else if ($body.attr("data-preloader") === "4") {
      $body.append($("<div class='preloader preloader-4'><div><span></span></div></div>"));
    }
    else if ($body.attr("data-preloader") === "5") {
      $body.append($("<div class='preloader preloader-5'><div><h6 class='heading-uppercase'>Loading</h6><span class='spinner'></span></div></div>"));
    }
    else if ($body.attr("data-preloader") === "6") {
      $body.append($("<div class='preloader preloader-6'><div><span class='spinner'><span></div></div>"));
    }    
  }
};
</script>

<style lang="scss">
@import "node_modules/bootstrap/scss/bootstrap";
@import "node_modules/bootstrap-vue/src/index.scss";
@import "assets/mono/css/scss/app.scss";

.cryptedmail:after {
  content: attr(data-name) "@" attr(data-domain) "." attr(data-tld);
}

</style>
